class DetailsDisclosure extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector('details');
		if (!this.mainDetailsToggle) return;

		this.mainDetailsToggle.addEventListener(
			'toggle',
			this.onToggle.bind(this)
		);

		this.addEventListener('keyup', this.onKeyUp.bind(this));
		document.addEventListener('click', this.onDocumentClick.bind(this));
	}

	onToggle() {
		if (this.mainDetailsToggle.open) {
			if(this.mainDetailsToggle?.querySelector('.typography-body') !== null){
				document.body.classList.add('drawer-open', 'mega-menu-open');
			}
		}
	}

	onKeyUp(event) {
		if (event.code !== 'Escape') return;
		if (!this.mainDetailsToggle.open) return;

		this.close();

		const summary = this.mainDetailsToggle.querySelector('summary');
		if (summary) summary.focus();
	}

	onDocumentClick(event) {
		if (!this.mainDetailsToggle.open) return;

		if (!this.contains(event.target)) {
			this.close();
		}
	}

	close() {
		document.body.classList.remove('drawer-open', 'mega-menu-open');

		setTimeout(() => {
			this.mainDetailsToggle.removeAttribute('open');
		}, 200);
	}
}

customElements.define('details-disclosure', DetailsDisclosure);